import React, { useEffect, useState } from "react";
import TeamsCollectionView from "../../components/teams/TeamsCollectionView";
import { useSeasonsStore } from "../../store/seasonsStore";
import { useTeamsStore } from "../../store/teamsStore";
import { Busy } from "../../components/Busy";
import useAuthStore from "../../store/authStore";
import MyTeamView from "../../components/teams/MyTeamView";
import { Text } from "../../components/catalyst/text";
import useInvitationStore from "../../store/invitationsStore";
import InviteToTeam from "../../components/teams/InviteToTeam";
import { EditTeam } from "../../components/teams/EditTeam";
import ShortlistPlayers from "../../components/teams/ShortlistPlayers";

const Teams: React.FC<any> = () => {
  const { currentSeason } = useSeasonsStore();
  const { teams, myTeam, currentView, isBusy, busyMessage, getTeams } =
    useTeamsStore();
  const { currentUser } = useAuthStore();
  const [filteredTeams, setFilteredTeams] = useState<any>([]);

  const { isBusy: isBusyInvites, busyMessage: busyMessageInvites } =
    useInvitationStore();

  const [search, setSearch] = useState("");
  useEffect(() => {
    const filterteam = (teams || []).filter(
      (team: any) => team.status !== "unapproved"
    );
    if (search) {
      setFilteredTeams(
        filterteam
          ? filterteam.filter((team: any) =>
              team.name.toLowerCase().includes(search.toLowerCase())
            )
          : []
      );
    } else {
      setFilteredTeams(filterteam);
    }
  }, [search, teams]);

  useEffect(() => {
    if (currentSeason) {
      getTeams(currentSeason.id);
    }
  }, [currentSeason]);

  return (
    <>
      {currentView === "teams" && (
        <div className="pt-3">
          <div className="sm:flex sm:items-center">
            <div className="flex flex-row flex-wrap gap-2 items-center">
              <h1 className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
                Teams
              </h1>
              <p className="text-sm text-gray-700 dark:text-gray-200">
                - Teams in the current season.
              </p>
            </div>
          </div>
          <MyTeamView
            myTeam={myTeam}
            currentUser={currentUser}
            currentSeason={currentSeason}
          />

          {teams && teams.length > 0 && (
            <TeamsCollectionView
              teams={filteredTeams}
              setSearch={setSearch}
              searchText={search}
            />
          )}
          {(!teams || teams.length === 0) && (
            <div className="flex flex-col items-center justify-center mt-10">
              <Text>
                There are no teams to display. Please check back later.
              </Text>
            </div>
          )}
        </div>
      )}
      {(currentView === "inviteOwner" || currentView === "invitePlayer") && (
        <div className="pt-3">
          <div className="sm:flex sm:items-center">
            <div className="flex flex-row flex-wrap gap-2 items-center">
              <h1 className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
                Teams
              </h1>
              <p className="text-sm text-gray-700 dark:text-gray-200">
                - Invite owners/players to team.
              </p>
            </div>
          </div>
          <InviteToTeam team={myTeam} inviteType={currentView} />
        </div>
      )}
      {currentView === "editTeam" && (
        <div className="pt-3">
          <div className="sm:flex sm:items-center">
            <div className="flex flex-row flex-wrap gap-2 items-center">
              <h1 className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
                Teams
              </h1>
              <p className="text-sm text-gray-700 dark:text-gray-200">
                - Edit my team details.
              </p>
            </div>
          </div>
          <EditTeam myTeam={myTeam} currentUser={currentUser} />
        </div>
      )}
      {currentView === "shortlistPlayers" && (
        <div className="pt-3">
          <div className="sm:flex sm:items-center">
            <div className="flex flex-row flex-wrap gap-2 items-center">
              <h1 className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
                Teams
              </h1>
              <p className="text-sm text-gray-700 dark:text-gray-200">
                - Edit my team details.
              </p>
            </div>
          </div>
          <ShortlistPlayers team={myTeam} />
        </div>
      )}
      {(isBusy || isBusyInvites) && (
        <Busy
          busyMessage={
            busyMessage
              ? busyMessage
              : busyMessageInvites
              ? busyMessageInvites
              : "Please wait..."
          }
        />
      )}
    </>
  );
};

export default Teams;
